export const videoDeletesKeys = {
  get_video_delete: () => ['GET_VIDEO_DELETE'] as const,
  single_video_delete: (deleteId: string) =>
    ['SINGLE_VIDEO_DELETE', deleteId] as const,
  get_videos_for_customer: (days: number) =>
    ['GET_VIDEOS_FOR_CUSTOMER', days] as const,
};
